"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetsService = void 0;
var _asset = require("../controllers/asset.controller");
var AssetsService = {
  asset: {
    root: _asset.config.asset + "/root",
    download: _asset.config.asset + "/download/image",
    downloadUrl: _asset.config.asset + "/download/url",
    update: _asset.config.asset,
    list: _asset.config.asset + "/list",
    delete: _asset.config.asset,
    preview: _asset.config.asset + "/preview",
    previewDoc: _asset.config.asset + "/preview/document",
    updateAccessPermission: _asset.config.asset + "/access-permission",
    addAccessPermission: _asset.config.asset + "/access-permission",
    coverImageList: _asset.config.asset + "/cover-image",
    getAccessPermission: _asset.config.asset + "/access-permission",
    preSignedUrl: _asset.config.asset + "/download/url/presigned",
    preSignedUrlRedirect: _asset.config.asset + "/download/url/presigned/redirect"
  },
  record: {
    list: _asset.config.record,
    delete: _asset.config.record,
    create: _asset.config.record,
    download: _asset.config.record + "/download",
    update: _asset.config.record
  },
  assetUpload: {
    uploadFundDefault: _asset.config.asset + "/upload/image/fund/default",
    uploadImpactDefault: _asset.config.asset + "/upload/image/impact/default",
    uploadPrintbridgeDefault: _asset.config.asset + "/upload/image/printbridge/default",
    uploadCroppedImage: _asset.config.asset + "/upload/image",
    uploadResource: _asset.config.asset + "/upload",
    profile: _asset.config.asset + "/upload/image/user",
    vCard: _asset.config.asset + "/upload/vcard/user",
    uploadImageForImpact: _asset.config.asset + "/upload/image/impact",
    uploadImageForFund: _asset.config.asset + "/upload/image/fund"
  },
  assetBulkUpload: {
    uploadBulkResource: _asset.config.asset + "/upload/bulk"
  },
  assetFolderView: {
    add: _asset.config.asset + "/folder",
    update: _asset.config.asset + "/folder",
    viewList: _asset.config.asset + "/folder/list",
    parentList: _asset.config.asset + "/folder/list/parents",
    initialList: _asset.config.asset + "/folder/list/initials",
    delete: _asset.config.asset + "/folder",
    fetch: _asset.config.asset + "/folder",
    updateAssetPermission: _asset.config.asset + "/folder/access-permission",
    addAssetPermission: _asset.config.asset + "/folder/access-permission",
    fetchAssetPermission: _asset.config.asset + "/folder/access-permission"
  },
  assetFolderDelete: {
    hardDeleteBulk: _asset.config.asset + "/folder/bulk/delete/hard",
    restoreBulk: _asset.config.asset + "/folder/bulk/delete/soft/restore",
    fetch: _asset.config.asset + "/folder/list/soft/deleted",
    restore: _asset.config.asset + "/folder/delete/soft/restore",
    softdelete: _asset.config.asset + "/folder/delete/soft"
  }
};
exports.AssetsService = AssetsService;